import { render, staticRenderFns } from "./TaskCard.vue?vue&type=template&id=15a67600&scoped=true&"
import script from "./TaskCard.vue?vue&type=script&lang=js&"
export * from "./TaskCard.vue?vue&type=script&lang=js&"
import style0 from "./TaskCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TaskCard.vue?vue&type=style&index=1&id=15a67600&scoped=true&lang=css&"
import style2 from "./TaskCard.vue?vue&type=style&index=2&id=15a67600&scoped=true&lang=css&"
import style3 from "./TaskCard.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a67600",
  null
  
)

export default component.exports